module.exports = __webpack_public_path__ + "static/media/operations-02.c22f4c98.svg";